export default __webpack_public_path__ + "static/media/phishing-indentify2.b56a9d8b.png";